import classnames from "classnames";
import DefaultIcon from "../components/icon.jsx";
const AccordionHeading = (props) => {
	// console.log("accordion heading props", props);
	const {
		// accessibilityClasses = "hover:bg-primary-200 focus:bg-gray-200",
		accessibilityClasses = "",
		// activeClasses = "text-gray-500",
		activeClasses = "",
		lookAndFeelClasses = "text-left p-2",
		onClick = () => {
			console.warn(
				"[ACCORDION HEADING]: Click handlers not bound in this context. If you find yourself seeing this message outside of the context of a backend system, please check props being passed in."
			);
		},
		onKeyDown = () => {
			console.warn(
				"[ACCORDION HEADING]: Key down handlers not bound in this context. If you find yourself seeing this message outside of the context of a backend system, please check props being passed in."
			);
		},
		isAdmin = false,
		active = false,
		idx = -1,
		showIcon = true,
		anchor = "accordion-anchor",
	} = props;

	const ButtonType = isAdmin ? "div" : "button";
	return (
		<ButtonType
			id={`${anchor}-${idx}-heading`}
			aria-controls={`${anchor}-${idx}-body`}
			data-react="AccordionHeading"
			className={classnames(
				`w-full flex justify-between items-center`,
				accessibilityClasses,
				lookAndFeelClasses,
				activeClasses
			)}
			aria-expanded={active ? "true" : "false"}
			// aria-expanded="false"

			onClick={(e) => onClick(e, idx)}
			onKeyDown={(e) => {
				onKeyDown({ e, idx });
			}}
		>
			{props.children}
			{showIcon && (
				<DefaultIcon
					className={classnames(
						`origin-center transform h-4 w-4 transition-transform ease-in-out duration-200`,
						active ? "rotate-45" : ""
					)}
				/>
			)}
		</ButtonType>
	);
};

export default AccordionHeading;
